export default {
  default: "0",
  readonly: "1",
  standard: "2",
  admin: "3",
  Admin: "3",
};
